import axios from "axios";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const subscriptionsApi = async () => {
  try {
    const apiLink = `${endpoint}/api/subscription`;
    const response = await axios.get(apiLink);
    const data = response.data;

    const dataArray = [];
    if (data) {
      data.forEach((elem) => {
        const obj = {
          endDate: elem.endDate || null,
          startDate: elem.startDate || null,
          status: elem.status || "",
          stripePaymentIntet: elem.stripePaymentIntet || "",
          stripeSessionId: elem.stripeSessionId || "",
          planName: elem.plan ? elem.plan.name : "",
          planDescription: elem.plan ? elem.plan.description : "",
          planPrice: elem.plan ? elem.plan.price : "",
          planCurrecyIsoCode: elem.plan ? elem.plan.currecyIsoCode : "",
          planBillingInterval: elem.plan ? elem.plan.billingInterval : "",
        };
        dataArray.push(obj);
      });
    }

    return dataArray;
  } catch (error) {
    if (error.response) {
      customToast.error(error.response.data?.message);
    } else {
      customToast.error(error.message);
    }
    throw error;
  }
};

export default subscriptionsApi;
